module.exports = __webpack_public_path__ + "img/20200115155838377.a46a5e20.jpg";